'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var interfaceDatastore = require('interface-datastore');

var shard = require('./shard.js');

var base = require('./base.js');

var keytransform = require('./keytransform.js');

var errors = require('./errors.js');

var shardReadme = require('./shard-readme.js');

var shardKey = new interfaceDatastore.Key(shard.SHARDING_FN);
var shardReadmeKey = new interfaceDatastore.Key(shard.README_FN);

var ShardingDatastore = /*#__PURE__*/function (_base$BaseDatastore) {
  _inherits(ShardingDatastore, _base$BaseDatastore);

  var _super = _createSuper(ShardingDatastore);

  function ShardingDatastore(store, shard) {
    var _this4;

    _classCallCheck(this, ShardingDatastore);

    _this4 = _super.call(this);
    _this4.child = new keytransform.KeyTransformDatastore(store, {
      convert: _this4._convertKey.bind(_assertThisInitialized(_this4)),
      invert: _this4._invertKey.bind(_assertThisInitialized(_this4))
    });
    _this4.shard = shard;
    return _this4;
  }

  _createClass(ShardingDatastore, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.child.open();

              case 2:
                _context.next = 4;
                return ShardingDatastore.create(this.child, this.shard);

              case 4:
                this.shard = _context.sent;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "_convertKey",
    value: function _convertKey(key) {
      var s = key.toString();

      if (s === shardKey.toString() || s === shardReadmeKey.toString()) {
        return key;
      }

      var parent = new interfaceDatastore.Key(this.shard.fun(s));
      return parent.child(key);
    }
  }, {
    key: "_invertKey",
    value: function _invertKey(key) {
      var s = key.toString();

      if (s === shardKey.toString() || s === shardReadmeKey.toString()) {
        return key;
      }

      return interfaceDatastore.Key.withNamespaces(key.list().slice(1));
    }
  }, {
    key: "put",
    value: function put(key, val, options) {
      return this.child.put(key, val, options);
    }
  }, {
    key: "get",
    value: function get(key, options) {
      return this.child.get(key, options);
    }
  }, {
    key: "has",
    value: function has(key, options) {
      return this.child.has(key, options);
    }
  }, {
    key: "delete",
    value: function _delete(key, options) {
      return this.child.delete(key, options);
    }
  }, {
    key: "putMany",
    value: function putMany(source) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(_this.child.putMany(source, options)), _awaitAsyncGenerator), "t0", 1);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "getMany",
    value: function getMany(source) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.delegateYield(_asyncGeneratorDelegate(_asyncIterator(_this2.child.getMany(source, options)), _awaitAsyncGenerator), "t0", 1);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }, {
    key: "deleteMany",
    value: function deleteMany(source) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(_this3.child.deleteMany(source, options)), _awaitAsyncGenerator), "t0", 1);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }, {
    key: "batch",
    value: function batch() {
      return this.child.batch();
    }
  }, {
    key: "query",
    value: function query(q, options) {
      var _this5 = this;

      var tq = {
        offset: q.offset,
        limit: q.limit,
        orders: [],
        filters: [function (e) {
          return e.key.toString() !== shardKey.toString();
        }, function (e) {
          return e.key.toString() !== shardReadmeKey.toString();
        }]
      };
      var prefix = q.prefix;

      if (prefix != null) {
        tq.filters.push(function (e) {
          return _this5._invertKey(e.key).toString().startsWith(prefix);
        });
      }

      if (q.filters != null) {
        var filters = q.filters.map(function (f) {
          var filter = function filter(_ref) {
            var key = _ref.key,
                value = _ref.value;
            return f({
              key: _this5._invertKey(key),
              value: value
            });
          };

          return filter;
        });
        tq.filters = tq.filters.concat(filters);
      }

      if (q.orders != null) {
        tq.orders = q.orders.map(function (o) {
          var order = function order(a, b) {
            return o({
              key: _this5._invertKey(a.key),
              value: a.value
            }, {
              key: _this5._invertKey(b.key),
              value: b.value
            });
          };

          return order;
        });
      }

      return this.child.query(tq, options);
    }
  }, {
    key: "queryKeys",
    value: function queryKeys(q, options) {
      var _this6 = this;

      var tq = {
        offset: q.offset,
        limit: q.limit,
        orders: [],
        filters: [function (key) {
          return key.toString() !== shardKey.toString();
        }, function (key) {
          return key.toString() !== shardReadmeKey.toString();
        }]
      };
      var prefix = q.prefix;

      if (prefix != null) {
        tq.filters.push(function (key) {
          return _this6._invertKey(key).toString().startsWith(prefix);
        });
      }

      if (q.filters != null) {
        var filters = q.filters.map(function (f) {
          var filter = function filter(key) {
            return f(_this6._invertKey(key));
          };

          return filter;
        });
        tq.filters = tq.filters.concat(filters);
      }

      if (q.orders != null) {
        tq.orders = q.orders.map(function (o) {
          var order = function order(a, b) {
            return o(_this6._invertKey(a), _this6._invertKey(b));
          };

          return order;
        });
      }

      return this.child.queryKeys(tq, options);
    }
  }, {
    key: "close",
    value: function close() {
      return this.child.close();
    }
  }], [{
    key: "createOrOpen",
    value: function () {
      var _createOrOpen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(store, shard) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return ShardingDatastore.create(store, shard);

              case 3:
                _context5.next = 9;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5["catch"](0);

                if (!(_context5.t0 && _context5.t0.message !== 'datastore exists')) {
                  _context5.next = 9;
                  break;
                }

                throw _context5.t0;

              case 9:
                return _context5.abrupt("return", ShardingDatastore.open(store));

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 5]]);
      }));

      function createOrOpen(_x, _x2) {
        return _createOrOpen.apply(this, arguments);
      }

      return createOrOpen;
    }()
  }, {
    key: "open",
    value: function () {
      var _open2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(store) {
        var shard$1;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return shard.readShardFun('/', store);

              case 2:
                shard$1 = _context6.sent;
                return _context6.abrupt("return", new ShardingDatastore(store, shard$1));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function open(_x3) {
        return _open2.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(store, shard$1) {
        var hasShard, put, diskShard, a, b;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return store.has(shardKey);

              case 2:
                hasShard = _context7.sent;

                if (!(!hasShard && !shard$1)) {
                  _context7.next = 5;
                  break;
                }

                throw errors.dbOpenFailedError(Error('Shard is required when datastore doesn\'t have a shard key already.'));

              case 5:
                if (hasShard) {
                  _context7.next = 10;
                  break;
                }

                put = typeof store.putRaw === 'function' ? store.putRaw.bind(store) : store.put.bind(store);
                _context7.next = 9;
                return Promise.all([put(shardKey, new TextEncoder().encode(shard$1.toString() + '\n')), put(shardReadmeKey, new TextEncoder().encode(shardReadme))]);

              case 9:
                return _context7.abrupt("return", shard$1);

              case 10:
                _context7.next = 12;
                return shard.readShardFun('/', store);

              case 12:
                diskShard = _context7.sent;
                a = (diskShard || '').toString();
                b = shard$1.toString();

                if (!(a !== b)) {
                  _context7.next = 17;
                  break;
                }

                throw new Error("specified fun ".concat(b, " does not match repo shard fun ").concat(a));

              case 17:
                return _context7.abrupt("return", diskShard);

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function create(_x4, _x5) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return ShardingDatastore;
}(base.BaseDatastore);

exports.ShardingDatastore = ShardingDatastore;